import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { useFormikContext, FieldArray, Field } from "formik";
import styled, { css } from "styled-components";
import isString from "lodash/isString";
import { HoverForHelp, SortableList } from "components/common";
import { Checkbox } from "components/bootstrap";
import FormErrors from "components/common/FormErrors";
import GroupingConfiguration from "./GroupingConfiguration";
import GroupingElement from "./GroupingElement";
import ElementConfigurationContainer from "../ElementConfigurationContainer";
const RollupColumnsCheckbox = styled(Checkbox)`
  &.checkbox {
    padding-top: 0;
  }
`;
const RollupColumnsLabel = styled.div`
  display: flex;
  align-items: center;
`;
const RollupHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
const SettingsSeparator = styled.hr(
  ({ theme }) => css`
    border-style: dashed;
    border-color: ${theme.colors.variant.lighter.default};
    margin-top: 5px;
    margin-bottom: 5px;
  `
);
const GroupingsConfiguration = () => {
  var _a, _b;
  const { t } = useTranslation("aggregation");
  const {
    values: { groupBy },
    values,
    errors,
    setValues,
    setFieldValue
  } = useFormikContext();
  const disableColumnRollup = !((_a = groupBy == null ? void 0 : groupBy.groupings) == null ? void 0 : _a.find(({ direction }) => direction === "column"));
  const removeGrouping = useCallback(
    (index) => () => {
      setValues(GroupingElement.onRemove(index, values));
    },
    [setValues, values]
  );
  const isEmpty = ((_b = groupBy == null ? void 0 : groupBy.groupings) != null ? _b : []).length === 0;
  const GroupingsItem = useCallback(
    ({ item, index, dragHandle, className, ref }) => /* @__PURE__ */ React.createElement(
      ElementConfigurationContainer,
      {
        key: `grouping-${item.id}`,
        dragHandle,
        className,
        onRemove: removeGrouping(index),
        elementTitle: t("wizard_common.grouping"),
        ref
      },
      /* @__PURE__ */ React.createElement(GroupingConfiguration, { index })
    ),
    [removeGrouping, t]
  );
  const hasGroupByError = isString(errors == null ? void 0 : errors.groupBy);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "groupBy.groupings",
      validateOnChange: false,
      render: () => /* @__PURE__ */ React.createElement(
        SortableList,
        {
          items: groupBy == null ? void 0 : groupBy.groupings,
          onMoveItem: (newGroupings) => setFieldValue("groupBy.groupings", newGroupings),
          customListItemRender: GroupingsItem,
          displayOverlayInPortal: true
        }
      )
    }
  ), !isEmpty && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SettingsSeparator, null), /* @__PURE__ */ React.createElement(ElementConfigurationContainer, { elementTitle: t("wizard_grouping.settings") }, /* @__PURE__ */ React.createElement(Field, { name: "groupBy.columnRollup" }, ({ field: { name, onChange, value } }) => /* @__PURE__ */ React.createElement(
    RollupColumnsCheckbox,
    {
      onChange: () => onChange({ target: { name, value: !(groupBy == null ? void 0 : groupBy.columnRollup) } }),
      checked: value != null ? value : false,
      disabled: disableColumnRollup
    },
    /* @__PURE__ */ React.createElement(RollupColumnsLabel, null, t("wizard_grouping.rollup_columns"), /* @__PURE__ */ React.createElement(RollupHoverForHelp, { title: t("wizard_grouping.rollup_columns") }, t("wizard_grouping.rollup_columns_help")))
  )))), hasGroupByError && /* @__PURE__ */ React.createElement(FormErrors, { errors: { groupBy: errors == null ? void 0 : errors.groupBy } }));
};
export default GroupingsConfiguration;
